import React, { Component } from 'react'
import Burger from './Burger/Burger';
import Controls from './Controls/Controls';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { addIngredients, removeIngredients } from '../../redux/actionCreators';

const mapStateToProps = state => {
    return {
        ingredients: state.ingredients,
        totalPrice: state.totalPrice,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addIngredients: (igtype) => dispatch(addIngredients(igtype)),
        removeIngredients: (igtype) => dispatch(removeIngredients(igtype)),
    }
}


class BurgerBuilder extends Component {
    state = {
        modalOpen: false,
    }
    addIngredients = type => {
        //console.log(type) yes
        this.props.addIngredients(type)
    }
    removeIngredients = type => {
        this.props.removeIngredients(type)
    }

    toggleModal = () => {
        this.setState({ modalOpen: !this.state.modalOpen })
    }

    handleCheckout = () => {
        this.props.history.push('/checkout')
    }
    render() {
        document.title = 'Burger Builder'
        return (
            <div>
                <div className='d-flex flex-column flex-md-row'>
                    <Burger
                        ingredients={this.props.ingredients}
                    />
                    <Controls
                        addIngredients={this.addIngredients}
                        removeIngredients={this.removeIngredients}
                        price={this.props.totalPrice}
                        modalToggler={this.toggleModal}
                    />
                </div>
                <Modal isOpen={this.state.modalOpen}>
                    <ModalHeader>Your Order Summary</ModalHeader>
                    <ModalBody>
                        {
                            this.props.ingredients.map(item => {
                                return <div key={item.type}><span style={{ textTransform: 'capitalize' }}>{item.type}</span>: {item.amount}</div>
                            })
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={this.handleCheckout}
                            style={{ backgroundColor: '#D70F64' }}
                        >Continue to Checkout</Button>
                        <Button onClick={this.toggleModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(BurgerBuilder);